import SsgFallback from '@components/SsgFallback'
import getWebsiteEMenu from '@data/queries/website/websiteEMenu'
import getWebsiteIdFromDomain from '@data/queries/website/websiteIdFromDomain'
import getWebsiteInitialData from '@data/queries/website/websiteInitialData'
import getWebsiteLocaleOnly from '@data/queries/website/websiteLocaleOnly'
import websiteSSRTranslations from '@helpers/misc/websiteSSRTranslations'
import EMenu from '@page-components/EMenu'
import Layout from '@page-components/Layout'
import NoWebsite from '@page-components/NoWebsite'
import {InferGetStaticPropsType} from 'next'
import {useRouter} from 'next/router'

export default function EMenuPage(props: InferGetStaticPropsType<typeof getStaticProps>) {
  const router = useRouter()
  if (router.isFallback) {
    return <SsgFallback />
  }

  if (!props.website) {
    return <NoWebsite />
  }

  return (
    <Layout initialData={props.initialData}>
      <EMenu emenu={props.emenu} />
    </Layout>
  )
}

export const getStaticProps = async context => {
  const websiteId = await getWebsiteIdFromDomain(context.params.hostname)
  const initialData = await getWebsiteInitialData(websiteId)
  const website = await getWebsiteLocaleOnly(websiteId)
  const emenu = await getWebsiteEMenu(context.params.emenuId)
  return {
    props: {
      ...(await websiteSSRTranslations(website)),
      websiteId,
      website,
      initialData,
      emenu
    },
    revalidate: 60 * 60 * 24
  }
}

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: true
  }
}
